import {
  AddPlanToStatesRequest,
  BasicPlanActionResponse,
} from '../../types/plans/types';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { post } from '../apiService';
import { invalidatePlansListCache } from './listPlans';

export const addPlanToStates = async (
  body: AddPlanToStatesRequest,
): Promise<{ data: BasicPlanActionResponse; loading: boolean }> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }
  const url = `/resourceMatrix/insurance/add_plan_to_states?customerId=${customer}`;
  let loading = true;
  try {
    const responseData = await post(
      url,
      body as unknown as Record<string, unknown>,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    invalidatePlansListCache();
    loading = false;
    return { data: responseData as BasicPlanActionResponse, loading };
  } catch (error) {
    loading = false;
    throw new Error('Failed to add plan to states');
  }
};
